module.exports = __webpack_public_path__ + "static/media/search-icon.a5249452.svg";